
/* injects from baggage-loader */
require('./style.scss');

import React from 'react';

const ToggleSwitch = (inputProps) => {
    return <label className="toggle-switch">
        <input type="checkbox" {...inputProps} />
        <span className="slider" />
    </label>;
};

export default ToggleSwitch;